// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1S8UH","footer":"ModalCreateQualiphyProcedure_footer__1LMd_","additionData":"ModalCreateQualiphyProcedure_additionData__ym_Ie"};